import { seo } from '../seo';
export { DomainPricePage as default } from '../../src/pages/Product/DomainPricePage';
export const meta = () => seo('domains.prices');
